module.exports = __webpack_public_path__ + "2d9b8131abed629dd244354828c501d4.svg";